<div class="rules table-container">
	<div class="search-container">
		<app-search-input
			placeholder="Search..."
			[inputStr]="currentRuleApiParams.name || ''"
			(inputChanged)="inputChanged($event)"
		></app-search-input>
		<app-action-button
			id="delete-rules-btn"
			[disabled]="!selectedRows.length"
			title="Delete"
			matIcon="delete"
			(buttonClicked)="deleteButtonClick(ruleIds)"
		></app-action-button>
	</div>
	<div class="header">
    <h2 class="heading-3">Rule List</h2>
		<p>{{ selectedRows.length }} asset(s) selected</p>
	</div>
	<ng-container *ngIf="getDataSource().data?.length > 0; else noData">
		<app-table
			[dataSource]="getDataSource()"
			[view]="view"
			[activeRowId]="clickedRule?.id"
			activeRowIdKey="id"
			(dataCheckboxEmitter)="disableDataCheckbox($event)"
			(toolTipEmitter)="enableToolTip($event)"
			(sortChange)="onMatSortChange($event)"
			(selectedRows)="selectedRowsReceived($event)"
			(sortObjChanged)="receiveSortObj($event)"
			(rowClicked)="onRowClick($event)"
			checkboxText="SELECT RULE"
		>
			<!-- rule -->
			<app-column
				name="Rule Name"
				id="ruleName"
				sortable="true"
				data="name"
				view="rules"
			></app-column>
			<!-- assigned assets -->
			<app-column
				id="assigned-assets"
				name="Assigned Assets"
				data="assignedAssets"
				view="rules"
			></app-column>
			<!-- date updated -->
			<app-column
				id="updated"
				name="Last Updated"
				data="updated"
				sortable="true"
				view="rules"
			></app-column>
			<!-- user who wrote rule -->
			<app-column
				id="userName"
				name="User"
				data="byUser"
				view="rules"
			></app-column>
		</app-table>
		<app-paginator
			[length]="paginatorLength"
      [page]="currentRuleApiParams.page || '1'"
			[pageSizeOptions]="pageSizeOptions"
			(pageQueryChange)="pageQueryChange($event)"
		></app-paginator>
	</ng-container>

	<ng-template #noData>
		<p *ngIf="!error">There are 0 rules.</p>
	</ng-template>

	<p *ngIf="error">An error occurred fetcthing the data.</p>
</div>

<ng-template #ruleErrors>
	<p class="evir-font-default">An error occurred while attempting to delete {{ failedRuleNames }}.</p>
</ng-template>
